export const beforeTestFAQs = [
    {
        question: 'What is the exam pattern of ANTHE 2.0?',
        answer: 'There will be a total of 40 questions for 90 marks with a duration of 1 hour with no negative marking.',
        type: 'text',
    },
    {
        question: 'Are there any practice tests available for ANTHE preparation?',
        answer: 'Yes, once registered, 1 sample paper is available free of cost and can be accessed by logging into <a href="https://anthedashboard.aakash.ac.in/login">ANTHE website</a>. If students wish to practice for ANTHE 2.0 exam, one may purchase 4 Mock Tests at INR 50',
        type: 'text',
    },
    {
        question: 'How and when students shall receive the Admit Cards?',
        type: 'text',
        answer: 'The students can download the Admit Cards from ANTHE website by 15th January 2025 and the communication regarding the same will also be sent through SMS & Whatsapp on the registered mobile number.',
    },
    {
        question:'Can a student give the exam on a Mobile Phone or Tablet?',
        type: 'text',
        answer: 'Yes',
    },
    {
        question: 'How you can change the class, stream and date of the exam?',
        type: 'text',
        answer: 'Students can change class, stream and date of exam by logging into <a href="https://anthedashboard.aakash.ac.in/login">ANTHE website</a> anytime before the last date of registration.',
    },
    {
        question: "What is the exam pattern and syllabus of ANTHE 2.0?",
        type: 'text',
        answer: 'There will be a total of 40 questions for 90 marks with a duration of 1 hour with no negative marking. Students can visit <a href="https://anthe.aakash.ac.in/syllabus">https://anthe.aakash.ac.in/syllabus</a> to get all the details regarding class wise ANTHE Test Syllabus.',
    },
    {
        question: "How many times a student can change the mode of the exam?",
        type: 'text',
        answer: 'Twice',
    }, 
    {
        question: "Which courses can I get a scholarship on through ANTHE?",
        type: 'text',
        answer: 'ANTHE gives students a chance to get up to 100%* Scholarship on Medical (NEET), Engineering (JEE) and Foundation courses.',
    },
    {
        question: "Can class 5th to 7th  studying students register for ANTHE?",
        type: 'text',
        answer: 'Yes. student currently studying in Class 5,6,7 can register for ANTHE and shall be eligible to take admission in next academic year courses.',
    },
    {
        question: "I am a 12th Passed student. Can I register for ANTHE?",
        type: 'text',
        answer: 'Yes. Class 12th Studying and Passed students are eligible to register for ANTHE. 12th Passed students can get admission in Aakash Repeater Classroom Courses in the next academic year.',
    },
    {
        question: "How will a student receive the latest update or any important information from ANTHE Team?",
        type: 'text',
        answer: 'All updates related to ANTHE will be communicated through Email, SMS & WhatsApp. Thus, the student has to ensure that the Phone no. & email are correct and in use.',
    },
    {
        question: "Where to contact if a student faces difficulty in online registration or needs clarification?",
        type: 'text',
        answer: 'Call us at 1800-103-2727 or email us at anthesupport@aesl.in',
    },
]

export const afterTestFAQs = [
    {
        question: 'Where is my exam center for Offline ANTHE 2.0?',
        answer: 'You will find the exam center on your admit card. You can download the admit card from Student Dashboard by logging in with your roll number and date of birth and clicking on Download Admit Card. The admit card will be available for download from 15th January, 2025',
        type: 'text',
    },
    {
        question: 'What are the supported browsers & operating systems to write ANTHE 2.0 Online?',
        answer: '<ul style="padding-left:3px;line-height:20px"><li>o Windows 7,8, 8.1 ,10 and Windows 11 Preferred Browser - Chrome, Edge, Firefox</li><li>o Android OS version (7, 8, 9, 10, 11, 12) in Chrome browser and Samsung Internet browser for Samsung devices</li><li>o MAC OS version 10 & above. Preferred browser: Chrome</li><li>o iOS version 10 & above. Preferred browser: Chrome</li></ul>',
        type: 'text',
    },
    {
        question: 'What should I do if ANTHE 2.0 Test is not showing on the dashboard?',
        type: 'text',
        answer: 'Please check the details for which tests are not visible. The Main Anthe 2.0 test card will always be visible on the dashboard. The status of the Main ANTHE 2.0 card can be<br/><ul style="padding-left:3px;line-height:20px"><li>o <strong> ‘Missed’ </strong>- If you did not give the exam on the intended date</li><li>o	 <strong>‘Upcoming’</strong> - If your exam is on the future date</li><li>o	<strong> ‘Start Now’</strong> - Status on the day of the test</li><li>o	<strong>‘View Result’</strong> - If you have submitted your test.</li></ul>',
    },
    {
        question:'What should we do if a student is not able to view questions/images of the test?',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs, and open the test in a new incognito window in the Chrome browser. The test attempts will remain intact <br/><br/>Steps to clear the cache on <strong>Chrome</strong><br/><ol><li>On your computer, open Chrome</li><li>	At the top right, click More.</li><li>Click More Tools and then Clear browsing data</li><li>At the top, choose a time range. To delete everything, select All time.</li><li>Next to "Cookies and other site data" and "Cached images and files," check the boxes.</li><li>Click Clear data</li></ol>',
    },
    {
        question: 'What should we do if a student submits the test by mistake?',
        type: 'text',
        answer: 'Call us on ANTHE Toll-Free No. <a href="tel:1800-103-2727">1800-103-2727<a/> or write us at <a href="mailto:anthesupport@aesl.in">anthesupport@aesl.in</a> for further Assistance.',
    },
    {
        question: "Question not appearing by clicking on the next button",
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs, and open the test in a new incognito window in Chrome browser. The test attempts will remain intact.',
    },
    {
        question: "When is the result of Anthe 2.0 being announced?",
        type: 'text',
        answer: '<ul style="padding-left:0px"><li>o	05th February 2025 (Wednesday) for Class X Studying Students</li><li>o	10th February 2025 (Monday) for Class V, VI, VII, VIII & IX Studying Students</li><li>o	12th February 2025 (Wednesday) for Class XI, XII Studying & XII Passed Students</li></ul>',
    }, 
    {
        question: "I have some questions regarding courses and the admission process. Can I talk to someone at Aakash?",
        type: 'text',
        answer: 'You can call us at <a href="tel:1800-102-2727">1800-102-2727<a/> Our admission assistance team will answer all your queries.',
    },
]
export const afterResultFAQ = [
    {
        question: 'Where is my exam center for Offline ANTHE 2.0?',
        answer: 'You will find the exam center on your admit card. You can download the admit card from Student Dashboard by logging in with your roll number and date of birth and clicking on Download Admit Card. The admit card will be available for download from 15th January, 2025',
        type: 'text',
    },
    {
        question: 'What are the supported browsers & operating systems to write ANTHE 2.0 Online?',
        answer: '<ul style="padding-left:3px;line-height:20px"><li>o Windows 7,8, 8.1 ,10 and Windows 11 Preferred Browser - Chrome, Edge, Firefox</li><li>o Android OS version (7, 8, 9, 10, 11, 12) in Chrome browser and Samsung Internet browser for Samsung devices</li><li>o MAC OS version 10 & above. Preferred browser: Chrome</li><li>o iOS version 10 & above. Preferred browser: Chrome</li></ul>',
        type: 'text',
    },
    {
        question: 'What should I do if ANTHE 2.0 Test is not showing on the dashboard?',
        type: 'text',
        answer: 'Please check the details for which tests are not visible. The Main Anthe 2.0 test card will always be visible on the dashboard. The status of the Main ANTHE 2.0 card can be<br/><ul style="padding-left:3px;line-height:20px"><li>o <strong> ‘Missed’ </strong>- If you did not give the exam on the intended date</li><li>o	 <strong>‘Upcoming’</strong> - If your exam is on the future date</li><li>o	<strong> ‘Start Now’</strong> - Status on the day of the test</li><li>o	<strong>‘View Result’</strong> - If you have submitted your test.</li></ul>',
    },
    {
        question:'What should we do if a student is not able to view questions/images of the test?',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs, and open the test in a new incognito window in the Chrome browser. The test attempts will remain intact <br/><br/>Steps to clear the cache on <strong>Chrome</strong><br/><ol><li>On your computer, open Chrome.</li><li>	At the top right, click More.</li><li>Click More Tools and then Clear browsing data</li><li>At the top, choose a time range. To delete everything, select All time.</li><li>Next to "Cookies and other site data" and "Cached images and files," check the boxes.</li><li>Click Clear data</li></ol>',
    },
    {
        question: 'What should we do if a student submits the test by mistake?',
        type: 'text',
        answer: 'Call us on ANTHE Toll-Free No. <a href="tel:1800-103-2727">1800-103-2727<a/> or write us at <a href="mailto:anthesupport@aesl.in">anthesupport@aesl.in</a> for further Assistance.',
    },
    {
        question: "Question not appearing by clicking on the next button",
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs, and open the test in a new incognito window in Chrome browser. The test attempts will remain intact.',
    },
    {
        question: "When is the result of Anthe 2.0 being announced?",
        type: 'text',
        answer: '<ul style="padding-left:0px"><li>o	05th February 2025 (Wednesday) for Class X Studying Students</li><li>o	10th February 2025 (Monday) for Class V, VI, VII, VIII & IX Studying Students</li><li>o	12th February 2025 (Wednesday) for Class XI, XII Studying & XII Passed Students</li></ul>',
    }, 
    {
        question: "I have some questions regarding courses and the admission process. Can I talk to someone at Aakash?",
        type: 'text',
        answer: 'You can call us at <a href="tel:1800-102-2727">1800-102-2727<a/> Our admission assistance team will answer all your queries.',
    },
    {
        question: 'What is the checklist for completing the admission process (Offline)',
        answer: '<ul style="padding-left:0px;line-height:26px"><li>Latest Marksheet</li><li>A valid I’d card (Passport, School I’d, etc) </li><li>Two recent colour passport size photographs</li><li>A chequebook to avail instalment payment mode</li></ul>',
        type: 'text',
    },
    {
        question: 'What are Aakash advantages?',
        answer: '<ul style="padding-left:0px;line-height:26px"><li className="text-dark-grey font-size-xs fw-lighter"><span style="color:#E7685A;font-size:14px;font-weight:600">A</span>dvanced technology driven teaching</li><li><span style="color:#FFD47F;font-size:14px;font-weight:600">D</span>ynamic academic edge</li><li><span style="color:#33C0F7;font-size:14px;font-weight:600">V</span>igorous testing system</li><li><span style="color:#6E42E5;font-size:14px;font-weight:600">N</span>etwork of safety., security and hygiene</li><li><span style="color:#B28A76;font-size:14px;font-weight:600">T</span>arget oriented study material</li><li><span style="color:#50B47F;font-size:14px;font-weight:600">A</span>ction oriented study feedback</li><li><span style="color:#50B47F;font-size:14px;font-weight:600">G</span>enunine care and attention</li><li><span style="color:#0F0F0F;font-size:14px;font-weight:600">E</span>xcellent results</li></ul>',
        type: 'text',
    },
]
